import { useMemo } from 'react';
import { useOrganizationContext } from '../service/context/organizationContext';
import { OrganizationUnitType } from '@inplay/models';

export type VenueBranchSelection = {
  label: string;
  value: string;
};

export const useVenueBranchAccess = () => {
  const { organizationSummary } = useOrganizationContext();

  // Filter and map venue branches to dropdown options
  const venueBranchOptions = useMemo(() => {
    return (
      organizationSummary
        ?.filter((org) => org.type === OrganizationUnitType.VENUE_BRANCH)
        .map((branch) => ({
          label: branch.name,
          value: branch._id,
        })) || []
    );
  }, [organizationSummary]);

  return {
    venueBranchOptions,
  };
};
